// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"castle-3"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M17 21V11H7V21H17Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 21H7V11H9V4H3V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 21V4H15V11H17V21H21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 4H3M9 4V11H7V21H3V4M9 4V3M3 4V3M21 4V21H17V11H15V4M21 4H15M21 4V3M15 4V3M12 21V16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17 21V11H7V21H17Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-castle-3')
export default class Castle3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-3',
    }
  }
}
